import React, { useState, useEffect } from 'react';
import { Row, Col, Input, FormGroup, Label } from 'reactstrap';
import { TemplateHistoryFilters, TemplateType } from '../types/template-history.types';

type Props = {
    filters: TemplateHistoryFilters;
    onChange: (key: keyof TemplateHistoryFilters, value: any) => void;
};

export const TemplateHistoryFiltersComp = ({ filters, onChange }: Props) => {
    const [agentNameInput, setAgentNameInput] = useState(filters.agentName ?? '');

    useEffect(() => {
        setAgentNameInput(filters.agentName ?? '');
    }, [filters.agentName]);

    useEffect(() => {
        const timer = setTimeout(() => {
            onChange('agentName', agentNameInput);
        }, 500);

        return () => clearTimeout(timer);
    }, [agentNameInput, onChange]);

    return (
        <Row className="mb-4">
            <Col md={4} sm={6}>
                <FormGroup>
                    <Label for="templateType">Canal de Envío</Label>
                    <Input
                        type="select"
                        name="templateType"
                        id="templateType"
                        value={filters.templateType || ''}
                        onChange={(e) => onChange('templateType', e.target.value as TemplateType | '')}
                    >
                        <option value="">Todos</option>
                        <option value="WHATSAPP">WhatsApp</option>
                        <option value="EMAIL">Correo</option>
                    </Input>
                </FormGroup>
            </Col>
            <Col md={4} sm={6}>
                <FormGroup>
                    <Label for="agentName">Agente</Label>
                    <Input
                        type="text"
                        name="agentName"
                        id="agentName"
                        placeholder="Buscar por Agente"
                        value={agentNameInput}
                        onChange={(e) => setAgentNameInput(e.target.value)}
                    />
                </FormGroup>
            </Col>
        </Row>
    );
};
